module.exports = __webpack_public_path__ + "img/乳液白底.c205b065.jpg";